import gql from 'graphql-tag'
import { RECRUITER_JOB_FRAGMENT } from '../apollo.fragment'

export const RECRUITER_SEARCH_JOBS_QUERY = gql`
	query recruiterSearchJobsQuery(
		$keyword: String
		$sort: SortArgument
		$externalJobId: String
		$filter: RecruiterJobFilter
		$nearBySearch: NearByJobSearch
		$token: String
		$after: String
		$before: String
		$first: Int
		$last: Int
	) {
		recruiterSearchJobs(
			keyword: $keyword
			sort: $sort
			externalJobId: $externalJobId
			filter: $filter
			nearBySearch: $nearBySearch
			token: $token
			after: $after
			before: $before
			first: $first
			last: $last
		) {
			totalCount
			pageInfo {
				hasNextPage
				hasPreviousPage
				endCursor
			}
			nodes {
				...recruiterJobFragment
			}
		}
	}

	${RECRUITER_JOB_FRAGMENT}
`
